import React, { useMemo, useState, Suspense } from "react";
import "./css/SuperStarGrid.css";

const SuperStarInstrumentsGrid = React.lazy(() => import("./SuperStarInstrumentsGrid"));
const GmailHoldingChangeFeed = React.lazy(() => import("./holdingChangeDisplay/GmailHoldingChangeFeed"));   // your new file
const GmailBulkDealChangeFeed = React.lazy(() => import("./holdingChangeDisplay/GmailBulkDealChangeFeed")); // your new file
const GmailBlockDealChangeFeed = React.lazy(() => import("./holdingChangeDisplay/GmailBlockDealChangeFeed"));

const TABS = {
    STOCKS: "STOCKS",
    HOLDING: "HOLDING",
    BULK: "BULK",
    BLOCK: "BLOCK", // ✅ add
};

export default function SuperStarGrid() {
    const [activeTab, setActiveTab] = useState(TABS.STOCKS);

    const Active = useMemo(() => {
        switch (activeTab) {
            case TABS.HOLDING:
                return GmailHoldingChangeFeed;
            case TABS.BULK:
                return GmailBulkDealChangeFeed;
            case TABS.BLOCK:
                return GmailBlockDealChangeFeed;
            case TABS.STOCKS:
            default:
                return SuperStarInstrumentsGrid;
        }
    }, [activeTab]);

    return (
        <div className="ssg-shell">
            <div className="ssg-tabs">
                <button
                    className={`ssg-tab ${activeTab === TABS.STOCKS ? "active" : ""}`}
                    onClick={() => setActiveTab(TABS.STOCKS)}
                >
                    Stocks
                </button>

                <button
                    className={`ssg-tab ${activeTab === TABS.HOLDING ? "active" : ""}`}
                    onClick={() => setActiveTab(TABS.HOLDING)}
                >
                    Holding Changes
                </button>

                <button
                    className={`ssg-tab ${activeTab === TABS.BULK ? "active" : ""}`}
                    onClick={() => setActiveTab(TABS.BULK)}
                >
                    Bulk Deals
                </button>

                <button
                    className={`ssg-tab ${activeTab === TABS.BLOCK ? "active" : ""}`}
                    onClick={() => setActiveTab(TABS.BLOCK)}
                >
                    Block Deals
                </button>

            </div>

            <div className="ssg-body">
                <Suspense
                    fallback={
                        <div className="ssg-loading">
                            <div className="ssg-spinner" />
                            <div>Loading…</div>
                        </div>
                    }
                >
                    <Active />
                </Suspense>
            </div>
        </div>
    );
}
